import { isNil } from 'lodash';
import * as orderService from 'services/orderService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { GetOrdersRequest } from 'services/dtoModels/order/getOrdersRequest';
import type { Paginator } from 'services/dtoModels/paginator';
import type { SWRResponse } from 'swr';

type SWROrdersData = Awaited<ReturnType<typeof orderService.getOrdersAsync>>;

const useOrders = (
  request: GetOrdersRequest & Paginator,
  load = true
): SWRResponse<SWROrdersData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDERS_ENDPOINT, request] : null,
    async ([_, params]) => await orderService.getOrdersAsync(params)
  );

export const SWR_ORDERS_ENDPOINT = 'orders';
export default useOrders;
